// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"_2qV_Tqo","buttonText":"_r7zOtzW","regulatoryText":"_RpWuiWq"};